import { Link, useParams } from 'react-router-dom'
import { AlertTriangle, TrendingDown, Heart, Zap, DollarSign, ArrowLeft } from 'lucide-react'

export function WhatIfScenarios() {
  const { clientId } = useParams()
  
  const scenarios = [
    {
      icon: TrendingDown,
      title: 'Bear Market at Retirement',
      description: '30% market decline in the year you retire',
      color: 'text-red-600',
      bg: 'bg-red-50',
    },
    {
      icon: Heart,
      title: 'Long-Term Care Need',
      description: 'LTC expenses of $100k/year for 3 years',
      color: 'text-purple-600',
      bg: 'bg-purple-50',
    },
    {
      icon: AlertTriangle,
      title: 'Disability',
      description: 'Income stops, expenses increase 20%',
      color: 'text-orange-600',
      bg: 'bg-orange-50',
    },
    {
      icon: Zap,
      title: 'Retirement Age Change',
      description: 'Retire 5 years earlier or later',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      icon: DollarSign,
      title: 'Increased Spending',
      description: 'Lifestyle inflation in retirement',
      color: 'text-green-600',
      bg: 'bg-green-50',
    },
    {
      icon: Heart,
      title: 'Family Support',
      description: 'Unexpected financial support for family',
      color: 'text-pink-600',
      bg: 'bg-pink-50',
    },
  ]
  
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center">
            <Link to={`/dashboard/${clientId}`} className="text-gray-600 hover:text-gray-900 mr-4">
              <ArrowLeft className="h-6 w-6" />
            </Link>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                What-If Scenarios
              </h1>
              <p className="text-sm text-gray-600">
                Stress-test your plan against different life events
              </p>
            </div>
          </div>
        </div>
      </header>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <h3 className="font-semibold text-blue-900 mb-2">Coming Soon</h3>
          <p className="text-blue-700 text-sm">
            This feature is under development. Soon you'll be able to model different scenarios
            and see how they impact your retirement success rate.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {scenarios.map((scenario, index) => (
            <div key={index} className="card hover:shadow-lg transition-shadow cursor-pointer">
              <div className={`w-12 h-12 ${scenario.bg} rounded-lg flex items-center justify-center mb-4`}>
                <scenario.icon className={`h-6 w-6 ${scenario.color}`} />
              </div>
              <h3 className="font-semibold text-lg mb-2">{scenario.title}</h3>
              <p className="text-sm text-gray-600">{scenario.description}</p>
              <button className="mt-4 text-primary-600 text-sm font-medium hover:text-primary-700">
                Run Scenario →
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
